// import { useObserver } from "mobx-react";
import { Observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useStores } from "../../store/index";
import TopicBasedInterview from "../dashboard/topicBasedInterview";
import Loader from "../reusble_components/loader";
import {
  getParamFromUrl,
  removeUnusedFieldsInObject,
} from "../../services/reusable";
import { apiGet } from "../../api/api_methods";
import { unUsedFieldsInInterviewObj } from "../../helpers/constantVariables";
import HelpCenter from "../reusble_components/helpCenter";

export default function InterviewInvitation({ takeInterview }) {
  const { PopupStore, InterviewStore } = useStores();

  const [loading, setloading] = useState(true);
  const [showForm, setshowForm] = useState(false);

  const getInterviewDetails = async () => {
    // const interviewId = getIdFromUrl();
    const interview_id = getParamFromUrl("meetingid");
    console.log("interview_id ->", interview_id);
    localStorage.removeItem("interviewIndex");

    if (interview_id === null) {
      setloading(false);
      return alert("Invalid URL");
    }
    // alert("Interview ID: " + interview_id);

    const apiLink = `/interview/get-interview-by-id/${interview_id}`;

    const response = await apiGet(apiLink);
    setloading(false);
    console.log("response ->", response);
    if (response.status === 200) {
      if (response.body.success) {
        console.log("response.body.data ->", response.body.data);
        localStorage.setItem(
          "customSettings",
          JSON.stringify(response.body.data.customSettings)
        );
        localStorage.setItem(
          "presentIteview",
          JSON.stringify(response.body.data)
        );
        InterviewStore.setValidation(true);
        try {
          InterviewStore.setResumeCompanyInterview(
            !response.body.data.customSettings[1].value
          );
          const userId = JSON.parse(localStorage.getItem("user"))?._id;
          localStorage.setItem(
            "interviewId",
            JSON.stringify(response.body.data._id)
          );
          const body = {
            attempts: response.body.data.customSettings[3].value,
            userId: userId,
            invitationFrom: response.body.data._id,
          };
          // const response = await apiPostPut(
          //   body,
          //   "interview/validate-custom-settings",
          //   "POST"
          // );
        } catch (e) {
        }

        // now remove some unnecessary fields from the response

        const filteredObject = removeUnusedFieldsInObject(
          response.body.data,
          unUsedFieldsInInterviewObj
        );
        console.log("filteredObject ->", filteredObject);

        console.log("interview", filteredObject?.interviewId);
        

        InterviewStore.setInterviewDetails({
          ...filteredObject,
          invitationFrom: response.body?.data?._id,
        });
       
        
        InterviewStore.setCustomQuestions(filteredObject?.customQuestions); // set the custom questions
        InterviewStore.enableInterviewFormById(
          filteredObject?.interviewId,
          null
        ); // enable the form using the interview form

        PopupStore.setTopicBasedInterview(true); // open the popup
        InterviewStore.setDefaultMaskingFields(); // set the default masking fields
        setshowForm(true);
        setloading(false);
        
      }
    } else {
      alert(response?.body?.message);
    }
  };

  useEffect(() => {
    getInterviewDetails();
    // PopupStore.setTopicBasedInterview(true);
  }, []);

  return (
    <Observer>
      {() => (
        <div className="gil-reg">
          <HelpCenter />
          <Loader loader={loading} />
          {showForm && (
            <TopicBasedInterview
              takeInterview={takeInterview} // this field is used to test the interview link
              popUpInitialValue={PopupStore.topicbasedinterview}
              handlePopup={() => {
                alert("You can't close this popup");
                //   PopupStore.setTopicBasedInterview(false);
              }}
            />
          )}
        </div>
      )}
    </Observer>
  );
}
